module.exports = __webpack_public_path__ + "img/face-meh.a26e1cca.svg";